// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"c9f313b1","551":"c2ddb01f","828":"6cc522b3","869":"b6dda42b"}[chunkId] + ".chunk.js";
};